import React, { useRef, useState } from 'react'
import { useServiceContext } from '../../root'
import SiteInfo from '../../components/staging/SiteInfo'
import { GridTableSwitch } from '../browser/GridTableSwitch'
import { RcmTableDataWrapper } from '../../components/rcm-table/RcmTableDataWrapper'
import Table from './SiteTable'
import { useStagingContext } from '../../routes/staging'

interface PageStagingSiteDocsProps {
  contextId?: string
}

const PageStagingSiteDocs: React.FC<PageStagingSiteDocsProps> = () => {
  const [totalElementsTracker, setTotalElementTracker] = useState<any>(null)
  const ref = useRef<HTMLDivElement>(null)
  const context = useServiceContext()
  const { service, api } = context
  const { translate } = service.filter
  const level: string = service.staging.getLevel?.() ?? ''
  const { contextId } = useStagingContext()

  // For parity, accept a single queryParams argument
  const loadData = (queryParams: any): Promise<{ elements: any[]; totalElements: number; hasNextPage?: boolean }> => {
    return new Promise((resolve, reject) => {
      queryParams.type = 'DOCUMENTS_FOR_LEVEL'
      queryParams.siteFsiId = contextId
      const totElTrackerCall = api.etmf.getSiteUserDocs(contextId ? contextId.toString() : '', queryParams)
      totElTrackerCall
        .then((data: any) => {
          setTotalElementTracker(data.totalElements)
          // Ensure the resolved value matches the expected shape
          resolve({
            elements: data.elements || [],
            totalElements: data.totalElements || 0,
            hasNextPage: data.hasNextPage
          })
        })
        .catch(reject)
    })
  }

  return (
    <div className="mcc-content-frame theme-sandman">
      <RcmTableDataWrapper
        doPreload={true}
        loadData={loadData}
        defaultSortBy={'name'}
        defaultSortDesc={false}
        persistenceKey={'persistenceKey'}
      >
        <div className="d-flex flex-wrap">
          <h1>{translate('SITE_DOCUMENTS_DOCS_FOR_SITE_TITLE')}</h1>
          <div className="align-right d-flex">
            <GridTableSwitch />
          </div>
        </div>
        <div className="clearfix">
          <div className="pull-left">
            <div className="mb20 mt20">
              <SiteInfo contextId={contextId ? contextId.toString() : ''} level={level} />
            </div>
          </div>
        </div>
        <div>
          <Table totalElements={totalElementsTracker} />
        </div>
      </RcmTableDataWrapper>
    </div>
  )
}

export default PageStagingSiteDocs
